module.exports = [
    {
        Title: 'Personnel identity management software',
        id: 'a0',
        Desc: 'People-centered, full-cycle, multi-dimensional personnel identity intelligent management, action, posture, line of sight and other information, integrate powerful intelligent algorithm and intelligent equipment, to form a unified personnel management software system.',
        img: [
            '1.png',
            '2.png',
        ],
        introduce: [

            {
                type: "html",
                class: 'd-a1',
                inner: `
        <p class= "tit"> System Profile </ p>
        <p> ● People-centered, multi-element intelligent detection </ p>
        <p> ● Take the scene as the coordinate, multiple point access </ p>
        <p> ● Personnel identity + behavior + positioning, comprehensive control </ p>
        <p> ● Personnel identity compliance, personnel trajectory compliance, personnel operation compliance </ p>
        <p> ● Multiple ways of disposal, scientific and effective </ p>
        
        `
            },
            {
                type: "html",
                class: 'd-a2',
                inner: `
        <p class= "tit"> Features and Advantage </ p>
        <p> ● High safety biometric, eliminate imposter </ p>
        <p> ● Convenient and efficient, to eliminate tedious </ p>
        <p> ● Divide regional authority and eliminate cross posts </ p>
        <p> ● Traceability, eliminate hosting </ p>
        `
            },


        ],
    },
    {
        Title: "clean service full lifecycle management software",
        id: 'a1',
        img: [
            '3.png',
            '4.png',
        ],
        Desc: 'clean service management system is a system used to manage and track the use, cleaning, maintenance and replacement activities of clean clothing. Clean clothing is a specially designed clothing, used to maintain the cleanliness and sterility of the working environment when working in a clean environment (such as medical, laboratory, electronic production and other places). The main functions of the clean service management system include: ',
        introduce: [

            {
                type: "html",
                class: 'd-b1',
                inner: `
        <p class= "tit"> System Profile </ p>
        <p> ● Receiving record of clean clothing: the system can record the information of each employee receiving clean clothing, including receiving time, quantity, employee name, etc., so as to realize the personalized management of clean clothing </ p>
        <p> ● Cleaning and maintenance of clean clothes: the system can track the cleaning and maintenance of clean clothes, including cleaning time, cleaning method, maintenance records, etc., to ensure the cleaning and sterility of clean clothes </ p>
        <p> ● Clean service period management: The system can set the replacement cycle of clean service and remind employees to replace the clean service in time to avoid expired use or pollution risk </ p>
        <p> ● Clean service inventory management: the system can monitor the inventory of clean service in real time, remind them to supplement in time, to ensure that employees have enough clean clothes to use </ p>
        <p> ● Approval process: the system can realize the approval process management of clean service, use and cleaning activities, and improve the management efficiency and standardization </ p>
        <p> ● Data report analysis: the system can generate clean service usage, cleaning records and other reports, to provide managers with data analysis and decision basis </ p>
        
        
        `,
            },
            {
                type: "html",
                class: 'd-b2',
                inner: `
        
        <p class= "tit"> Features and Advantage </ p>
        <p> ● Improve work efficiency: clean service management system can reduce the cost of labor management, improve work efficiency, and reduce errors and problems caused by poor management </ p>
        <p> ● Strengthen the control of the clean environment: through the standard management of the clean service management system, it can strengthen the control of the clean environment and improve the cleanliness and sterility of the working environment </ p>
        <p> ● Improve safety: The clean service management system can remind employees to replace the clean service in time, reduce the risk of pollution, and improve the safety of the workplace </ p>
        <p> ● Data statistics and analysis: the system can generate a data report on the use of clean clothing, help managers to analyze the use of clean clothing, find problems and timely correct </ p>
        <p> ● Standard management process: the clean service management system can standardize the use and cleaning process of the clean service, and ensure the standardization and scientific nature of the management process </ p>
        `,
            }
        ],
    },
    {
        Title: 'Personnel behavior management software',
        id: 'a2',
        img: [
            '5.png',
            '6.png',
        ],
        Desc: 'With the intelligent behavior analysis algorithm as the core, it analyzes and understands the behaviors and actions of personnel, and uses the latest artificial intelligence technologies such as AIGC, computer vision and natural language processing to solve the difficult management problems of related industries to the greatest extent.',
        introduce: [

            {
                type: "html",
                class: 'd-c1',
                inner: `
        <p class= "tit"> System Profile </ p>
        <p> ● Through AI vision technology and high-performance intelligent algorithm, the system realizes active illegal action detection and action posture detection, greatly improving the emergency response and management ability of enterprises </ p>
        
        `
            },
            {
                type: "html",
                class: 'd-c2',
                inner: `
        
        <p class= "tit"> Features and Advantage </ p>
        <p> ● Timely alarm of violations to ensure personal and environmental safety </ p>
        <p> ● Alarm screen visual display, improve the efficiency of personnel management </ p>
        `
            }
        ],
    },
    {
        Title: 'Electronic experiment book (ELN)',
        id: 'a3',
        img: [
            '7.png',
            '8.png',
        ],
        Desc: 'For the business pain points such as the laboratory management disorder, high experimental data turnover rate, difficult safety management, and difficult sharing and inheritance, a real, complete and traceable electronic experiment record system is formed based on intelligent equipment management, intelligent project management, experimental data management, and experimental material management.',
        introduce: [

            {
                type: "html",
                class: 'd-d1',
                inner: `
        <p class= "tit"> System Profile </ p>
        <p> The main function of ● ELN system is to replace the traditional paper experiment notebook, and record experimental data, experimental process and experimental results in electronic form </ p>
        
        
        `
            },
            {
                type: "html",
                class: 'd-d2',
                inner: `
        
        <p class= "tit"> Features and Advantage </ p>
        <p> ● Electronic record: ELN system records experimental data, experimental process, experimental results and other information in electronic form, avoiding the cumbersome and easy problems of traditional paper records </ p>
        <p> ● Traceability: The ELN system can track the entire experimental process, including experimental planning, experimental execution, data recording and other steps, to ensure the accuracy and credibility of the experimental data </ p>
        <p> ● Data sharing and collaboration: The ELN system supports multiple people to share experimental data, and team members can easily view, edit and share data, promoting teamwork and communication </ p>
        <p> ● Data analysis and reporting: The ELN system has the function of data analysis, which can statistics, analyze and visualize experimental data, generate reports and charts to help researchers better understand the data and results </ p>
        <p> ● Data security: The ELN system provides data encryption, permission control and backup functions to ensure the security of experimental data and prevent data leakage and loss </ p>
        <p> ● Improve efficiency: The ELN system can simplify the experimental recording process, reduce manual operation, improve work efficiency, and enable researchers to focus on experimental design and data analysis </ p>
        
        `
            },
        ],
    },
    {
        Title: ' The artificial intelligence algorithm platform',
        id: 'a4',
        img: [
            '9.png',
            '10.png',
            '11.png',
        ],
        Desc: 'The artificial intelligence research and development platform is complex AI system and a bridge between complex business system, can business requirements through machine learning, natural language processing, visual technology, technology of intelligent decision-making artificial intelligence means into the business management, at the same time can effectively protect the data security, save manpower cost',
        introduce: [

            {
                type: "html",
                class: 'd-e1',
                inner: `
        <p class= "tit"> Platform Introduction </ p>
        <p> ● interacts with the intelligent system through speech and text in a natural language way, realizing a huge leap from the information system to the intelligent assistant </ p>
        
        
        `
            },
            {
                type: "html",
                class: 'd-e2',
                inner: `
        <p class= "tit,"> Platform Advantage </ p>
        <p> ● The system can obtain the operation records of the scientific researchers and upload them to the system in real time through the connection with the relevant equipment of the laboratory </ p>
        
        `
            },
            {
                type: "html",
                class: 'd-e3',
                inner: `
        
        
        
        <p class= "tit"> Industry Promotion </ p>
        <p> ● Electronic record of the whole process, reduce manpower operation </ p>
        <p> ● Data is real, safe and reliable </ p>
        
        `
            }
        ],
    },
];